import { render, staticRenderFns } from "./NovaAssinaturaPJ.vue?vue&type=template&id=31f5555a&"
import script from "./NovaAssinaturaPJ.vue?vue&type=script&lang=js&"
export * from "./NovaAssinaturaPJ.vue?vue&type=script&lang=js&"
import style0 from "./NovaAssinaturaPJ.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports